<template>
    <component :is="pWrapperEl" class="draggable-container">
        <template v-for="(item, index) in items" :key="item[pKeyAttribute]? item[pKeyAttribute] : index">
            <component :is="pWrapperEl == 'ul' || pWrapperEl == 'ol'? 'li' : pWrapperEl" v-if="pAllowDropAround" class="drag-above"
                @dragover="onDragOver($event, index, pGroupName)"
                @drop="onDropAbove($event, index, pGroupName)"
            ></component>
            <component :is="pWrapperEl == 'ul' || pWrapperEl == 'ol'? 'li' : pWrapperEl"
                class="drag-content"
                tabindex="-1"
                :draggable="canDrag"
                :class="{ dragging: isDragging && draggedIndex === index, 'is-disabled': isDragging && draggedIndex !== index }"
                @mousedown="onMouseDown($event, index)"
                @dragstart="onDragStart($event, index)"
                @dragover="onDragOver($event, index, pGroupName)"
                @drop="onDrop($event, index, pGroupName)"
            >
                <slot
                    name="item"
                    v-bind="{item, index}"
                    >
                        <div v-html="item.titulo"></div>
                </slot>
              </component>
            <component :is="pWrapperEl == 'ul' || pWrapperEl == 'ol'? 'li' : pWrapperEl" v-if="pAllowDropAround" class="drag-below"
                @dragover="onDragOver($event, index, pGroupName)"
                @drop="onDrop($event, index, pGroupName)"></component>
        </template>
      </component>
  </template>
  <script>
  export default {
    name: "TrfDraggable",
    emits: ['changed:items'],
    props: {
      pItems: {
        type: Array,
        default: () => [],
      },
      pUseCustomHandler: {
        type: Boolean,
        default: false
      },
      pCustomHandlerClass: {
        type: String
      },
      pGroupName: {
        type: String,
        default: null
      },
      pAllowDropAround: {
        type: Boolean,
        default: true
      },
      pWrapperEl: {
        type: String,
        default: 'div'
      },
      pKeyAttribute: {
        type: String,
        deafult: 'id'
      }
    },
    data() {
      return {
        items: this.pItems,
        isDragging: false,
        draggedIndex: null,
        canDrag: !this.pUseCustomHandler
      };
    },
    watch: {
      pItems: {
        immediate: true,
        handler(novosDados) {
          this.items = novosDados
        },
        deep: true
      },
    },
    methods: {
        onMouseDown(event, index) {
            if (!this.pUseCustomHandler || (this.pUseCustomHandler && event.target.classList.contains(this.pCustomHandlerClass))) {
                event.stopPropagation();
                this.draggedIndex = index;
                this.canDrag = true;
            } else {
                this.draggedIndex = null;
                this.canDrag = false;
            }
        },
        onDragStart(event, index) {
            if (this.canDrag && this.draggedIndex === index) {
                event.stopPropagation()
                this.isDragging = true;
                event.dataTransfer.setData('text/plain', '');
            } else {
                event.preventDefault();
            }
        },
        onDragOver(event, index, groupName) {
          if(!this.pGroupName || this.pGroupName === groupName) {
            event.preventDefault()
            event.stopPropagation()
          }
        },
        onDrop(event, dropIndex, groupName) {
            if(this.pGroupName && this.pGroupName !== groupName) {
              event.preventDefault()
              event.stopPropagation()
              this.resetDragState();
              this.focusOnDragged(dropIndex)
              return
            }
            if (this.draggedIndex !== null && dropIndex !== this.draggedIndex) {
              this.moveItem(dropIndex)
            }
            this.resetDragState();
            this.focusOnDragged(dropIndex)
        },
        onDropAbove(event, dropIndex, groupName) {
            if(this.pGroupName && this.pGroupName !== groupName) {
              event.preventDefault()
              event.stopPropagation()
              this.resetDragState();
              this.focusOnDragged(dropIndex)
              return
            }
          const isValidDropAbove = dropIndex != this.draggedIndex;
          const nextDropIndex = dropIndex + 1;
          if (isValidDropAbove && this.draggedIndex !== null && nextDropIndex !== this.draggedIndex) {
            this.moveItem(nextDropIndex)
          }
            this.resetDragState();
            this.focusOnDragged(nextDropIndex)
        },
        moveItem(index) {
          const newItems = [...this.items];
          const [draggedItem] = newItems.splice(this.draggedIndex, 1);
          newItems.splice(index, 0, draggedItem);
          this.items = newItems;
          this.emitItems(this.items)
        },
        resetDragState() {
          this.draggedIndex = null;
          this.isDragging = false;
          this.canDrag = false;
        },
        async focusOnDragged(index) {
          if(!this.$parent.$el.querySelectorAll('.box-edicao')[index]) return;
          await this.$nextTick();
          const element = this.$parent.$el.querySelectorAll('.box-edicao')[index];
          element.focus();
        },
        emitItems(items) {
            this.$emit('changed:items', items)
        },
        warnInvalidKeys() {
          if(process.env.NODE_ENV === 'production') return;
          const hasInvalidKeys = this.pItems.some(item => !item[this.pKeyAttribute]);
          if (hasInvalidKeys) {
            console.warn(`WARN: Componente Draggable iniciado com keys invalidas (Apontando para ${this.pKeyAttribute}), utilizando index como fallback padrão!`)
            console.warn("Utilizar index como key pode gerar comportaentos inesperados quando trabalhando com objetos complexos, por favor de prioridade a um id (se necessário gere dinamicamente na montagem do objeto usando o uuid.utils.js)")
          }
        }
    },
    mounted() {
      this.warnInvalidKeys()
    },
  };
  </script>

  <style scoped>
  .draggable-container .dragging {
    opacity: 0.5;
  }
  .draggable-container .is-disabled > * {
    pointer-events: none;
  }
  .drag-above, .drag-below {
    display: inline-block;
    width:100%;
    height: 1rem;
  }
  </style>